import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { searchCampaigns } from 'functions/campaign'

import useDebounce from 'hooks/useDebounce'
import useSetState from 'hooks/useSetState'

import Image from 'suitTheme/Image'
import InputSearch from 'suitTheme/InputSearch'

import defaultCampaignImageUrl from 'assets/images/campaign/default_campaign_image_75x75.png'

const mapResults = campaigns => ({
  groups: [
    {
      key: 'campaigns',
      title: 'CAMPAIGNS',
      items: campaigns.map(campaign => ({
        address: campaign.address,
        agent_ids: campaign.agent_ids,
        iconLeft: (
          <Image circle url={campaign.default_image} placeholderUrl={defaultCampaignImageUrl} width={30} height={30} />
        ),
        id: campaign.id,
        imageUrl: campaign.default_image || defaultCampaignImageUrl,
        key: campaign.id,
        suburb_name: campaign.suburb_name,
        text: campaign.title,
      })),
    },
  ],
})

const search = (string, setState, requestOptions) => {
  setState({ loading: true, results: null })

  searchCampaigns(string, { include_campaign_image: true, ...requestOptions }).then(
    ({ success, result }) => {
      if (success){
        setState({
          results: mapResults(result),
          loading: false,
        })
        return
      }

      setState({
        loading: false,
        results: null,
      })
    },
  )
}

const defaultState = {
  filterString: '',
  loading: false,
  results: null,
}

const SearchCampaigns = (props) => {
  const {
    boxProps, callbacks, forwardProps, requestOptions,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { filterString, results } = state

  const debouncedString = useDebounce(filterString, 300)

  useEffect(() => {
    if (debouncedString.length >= 2){
      search(debouncedString, setState, requestOptions)
    }

    // Clearing input
    if (!debouncedString.length){
      setState({ results: null })
    }
  }, [debouncedString])

  return (
    <InputSearch
      boxProps={boxProps}
      callbacks={callbacks}
      onChange={e => setState({ filterString: e.target.value })}
      results={results}
      value={filterString}
      {...forwardProps}
    />
  )
}

SearchCampaigns.propTypes = {
  boxProps: PropTypes.object,
  requestOptions: PropTypes.object,
  callbacks: PropTypes.shape({
    selectItem: PropTypes.func.isRequired,
  }).isRequired,
  forwardProps: PropTypes.object,
}

export default SearchCampaigns
